import { createApp } from 'vue';
import SearchBuilder from '@/vue/components/SearchBuilder.vue';
import SeminarYoutubePlayer from '@/vue/components/SeminarYoutubePlayer.vue';

/**
 * Vue.js v3
 *
 * @memo: 本当は #app に対してmountしたいが、
 * Vanilla js で DOM操作している箇所があるので、
 * vueのスコープを限定的にするために、インスタンスを小分けにする
 */

/* eslint-disable vue/one-component-per-file */

const searchBuilder = createApp({
  components: {
    AppSearchBuilder: {
      template: `<SearchBuilder v-model:prefecture-id="prefectureId" />`,
      components: { SearchBuilder },
      data: () => ({ prefectureId: 1 }),
    },
  },
});
searchBuilder.mount('#search-builder');

const appTheContent = createApp({
  components: {
    SeminarYoutubePlayer,
  },
});
appTheContent.mount('#use-vue-content');
